import { SetStateTuple, State } from '@/types/State';
import { useReducer } from 'react';

// does not support setState callbacks
export default function useSetState(initialState: State): SetStateTuple {
    const [state, setState] = useReducer((state, newState) => ({ ...state, ...newState }), initialState);
    return [state, setState];
}
